import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_29246_1284)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.33285 7.99995C9.33285 8.55195 8.88485 8.99995 8.33285 8.99995C7.78085 8.99995 7.33285 8.55195 7.33285 7.99995C7.33285 7.44795 7.78085 6.99995 8.33285 6.99995C8.88485 6.99995 9.33285 7.44795 9.33285 7.99995ZM11.6662 6.99995C11.1142 6.99995 10.6662 7.44795 10.6662 7.99995C10.6662 8.55195 11.1142 8.99995 11.6662 8.99995C12.2182 8.99995 12.6662 8.55195 12.6662 7.99995C12.6662 7.44795 12.2182 6.99995 11.6662 6.99995ZM4.99952 6.99995C4.44752 6.99995 3.99952 7.44795 3.99952 7.99995C3.99952 8.55195 4.44752 8.99995 4.99952 8.99995C5.55152 8.99995 5.99952 8.55195 5.99952 7.99995C5.99952 7.44795 5.55152 6.99995 4.99952 6.99995ZM16.3329 8.22661V12.6666C16.3329 14.5046 14.8375 15.9999 12.9995 15.9999H9.05485C4.38752 15.9999 0.646186 12.8053 0.352853 8.56928C0.192186 6.25195 1.03752 3.98395 2.67219 2.34728C4.30685 0.710614 6.57485 -0.137386 8.89019 0.019281C13.0635 0.302614 16.3329 3.90728 16.3329 8.22661ZM14.9995 8.22661C14.9995 4.60595 12.2769 1.58528 8.80019 1.34928C8.64752 1.33861 8.49485 1.33395 8.34285 1.33395C6.57219 1.33395 4.87019 2.03261 3.61552 3.28928C2.25285 4.65328 1.54819 6.54461 1.68285 8.47728C1.93152 12.0639 5.03219 14.6673 9.05552 14.6673H13.0002C14.1029 14.6673 15.0002 13.7699 15.0002 12.6673V8.22728L14.9995 8.22661Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29246_1284",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0.333008)"
		})
	}) })]
});
export default SvgMessage;
